import { Link } from 'wouter';
import { ADMIN_ROUTES } from '../../../routes/consts';

export const AdminHome = () => {
  return (
    <div className='flex flex-col gap-4 justify-center items-center'>
      <h1 className='text-4xl '>Welcome to the MovingWorlds admin portal</h1>
      <p>Take me to...</p>
      <ul className='text-center'>
        <AdminQuickLink text='Corporates' href={ADMIN_ROUTES.CORPORATES} />
        <AdminQuickLink text='Organizations' href={ADMIN_ROUTES.ORGANIZATIONS} />
        <AdminQuickLink text='Projects' href={ADMIN_ROUTES.PROJECTS} />
        <AdminQuickLink text='Professionals' href={ADMIN_ROUTES.PROFESSIONALS} />
      </ul>
    </div>
  );
};

const AdminQuickLink = (props: { text: string; href: string }) => {
  return (
    <li className='mb-2'>
      <Link className='text-blue-600 underline' to={props.href}>
        {props.text}
      </Link>
    </li>
  );
};
